import { render, staticRenderFns } from "./StoreGroupbuyingDraft.vue?vue&type=template&id=4f5e7ae7&scoped=true&"
import script from "./StoreGroupbuyingDraft.vue?vue&type=script&lang=js&"
export * from "./StoreGroupbuyingDraft.vue?vue&type=script&lang=js&"
import style0 from "./StoreGroupbuyingDraft.vue?vue&type=style&index=0&id=4f5e7ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e7ae7",
  null
  
)

export default component.exports